import { api, unwrap } from "@lumberset/api-client";
import { queryOptions } from "@tanstack/react-query";

/** The signed-in Staff member's own numbers and recent work, for My work. */
export const myWorkQuery = queryOptions({
  queryKey: ["staff", "work"],
  queryFn: () => unwrap(api.staff.work.$get()),
});

export type MyWork = Awaited<ReturnType<NonNullable<typeof myWorkQuery.queryFn>>>;
